export var ANALYTICS_CHANNEL = 'jql-editor';
export var EventType = /*#__PURE__*/function (EventType) {
  EventType["OPERATIONAL"] = "operational";
  EventType["SCREEN"] = "screen";
  EventType["TRACK"] = "track";
  EventType["UI"] = "ui";
  return EventType;
}({});